export default __webpack_public_path__ + "static/media/fail.db62dda6.png";